import { render, staticRenderFns } from "./faturamento.vue?vue&type=template&id=3eb8b656&"
import script from "./faturamento.vue?vue&type=script&lang=js&"
export * from "./faturamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports